import { useFetchLanguage } from './useFetchLanguage'

const all = () => {
  const { getAll } = useFetchLanguage()

  return useAsyncState(getAll, [])
}

export const useQueryLanguage = {
  all,
}
